/**
 * Extrae un mensaje legible de una respuesta de error de la API (axios).
 */
export function extractApiErrorMessage(error, fallback = 'Ocurrió un error') {
  const data = error?.response?.data
  if (!data) {
    return error?.message || fallback
  }
  if (typeof data === 'string') {
    return data
  }
  if (data.error && typeof data.error === 'string') {
    return data.error
  }
  if (data.detail) {
    if (typeof data.detail === 'string') {
      return data.detail
    }
    if (Array.isArray(data.detail)) {
      return data.detail.map(String).join(' ')
    }
    if (typeof data.detail === 'object') {
      const parts = []
      for (const value of Object.values(data.detail)) {
        if (Array.isArray(value)) {
          parts.push(...value.map(String))
        } else if (value != null) {
          parts.push(String(value))
        }
      }
      if (parts.length) {
        return parts.join(' ')
      }
    }
  }
  if (typeof data === 'object') {
    const parts = []
    for (const value of Object.values(data)) {
      if (Array.isArray(value)) {
        parts.push(...value.map(String))
      } else if (typeof value === 'string') {
        parts.push(value)
      }
    }
    if (parts.length) {
      return parts.join(' ')
    }
  }
  return fallback
}
